import { render } from "./Bookshelf.vue?vue&type=template&id=37abd2cc"
import script from "./Bookshelf.vue?vue&type=script&lang=js"
export * from "./Bookshelf.vue?vue&type=script&lang=js"

import "./Bookshelf.vue?vue&type=style&index=0&id=37abd2cc&lang=scss"

import exportComponent from "/Users/pamelamontanez/Documents/projects/personal-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__